// extracted by mini-css-extract-plugin
export var container = "Quote-module--container--z86fQ";
export var lineLink = "Quote-module--line-link--2OlDB";
export var lineLink_black = "Quote-module--line-link_black--6lbDe";
export var lineLink_grey = "Quote-module--line-link_grey--NoSxo";
export var lineLink_primary = "Quote-module--line-link_primary--Vd38k";
export var lineLink_secondary = "Quote-module--line-link_secondary--IdKF3";
export var lineLink_white = "Quote-module--line-link_white--rR9uE";